// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__dZVZ_","bigColWidth":"Table_bigColWidth__3Q6JD","biggerColWidth":"Table_biggerColWidth__1GZ4l","row":"Table_row__bmT7i","col":"Table_col__38yOp"};